import React from 'react';
import './cancelPenalty.scss';

const CancelPenalty = ({ message, percentage, isMobile, darkMode = false }) => {
  return (
    <section
      className={`w-100 p-0 d-flex flex-column align-items-center  ${
        darkMode ? 'text-white' : 'text-primary'
      }`}
    >
      <span className="py-1 pb-0 font-smaller d-flex flex-wrap text-center">
        {message}
      </span>

      <svg
        className={`circle-chart`}
        viewBox="0 0 33.83098862 33.83098862"
        width={50}
        height={50}
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className="circle-chart__background"
          stroke="#efefef"
          strokeWidth={2}
          fill="none"
          cx="16.91549431"
          cy="16.91549431"
          r="15.91549431"
        />
        <circle
          className="circle-chart__circle"
          stroke="#00798c"
          strokeWidth={2}
          strokeDasharray={`${percentage},100`}
          strokeLinecap="round"
          fill="none"
          cx="16.91549431"
          cy="16.91549431"
          r="15.91549431"
        />
        <g className="circle-chart__info">
          <text
            className={`circle-chart__percent `}
            x="17px"
            y="17px"
            alignmentBaseline="central"
            textAnchor="middle"
            fill={`${darkMode ? '#efefef' : '#000'}`}
            fontSize={9}
          >
            {`${percentage}%`}
          </text>
        </g>
      </svg>
    </section>
  );
};
export default CancelPenalty;
